import { Box, Stack, Typography, Chip } from '@mui/joy';
import {
  PersonAdd,
  EventNote,
  CheckCircle,
  Cancel,
  FolderOpen,
  Assignment,
} from '@mui/icons-material';
import { formatDistanceToNow } from 'date-fns';
import type { ActivityFeedItem } from '@/types/dashboard';

const EVENT_CONFIG: Record<string, { icon: React.ReactElement; color: 'primary' | 'success' | 'danger' | 'warning' | 'neutral' }> = {
  user_created:              { icon: <PersonAdd fontSize="small" />,   color: 'primary' },
  schedule_published:        { icon: <EventNote fontSize="small" />,   color: 'success' },
  change_request_approved:   { icon: <CheckCircle fontSize="small" />, color: 'success' },
  change_request_rejected:   { icon: <Cancel fontSize="small" />,      color: 'danger' },
  change_request_created:    { icon: <Assignment fontSize="small" />,  color: 'warning' },
  project_created:           { icon: <FolderOpen fontSize="small" />,  color: 'primary' },
};

interface ActivityItemProps {
  item: ActivityFeedItem;
}

export default function ActivityItem({ item }: ActivityItemProps) {
  const config = EVENT_CONFIG[item.event_type] || { icon: <Assignment fontSize="small" />, color: 'neutral' as const };

  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ py: 1 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: `${config.color}.softBg`,
          color: `${config.color}.softColor`,
          flexShrink: 0,
          mt: 0.25,
        }}
      >
        {config.icon}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography level="body-sm" fontWeight="lg">
          {item.title}
        </Typography>
        <Typography level="body-xs" color="neutral" noWrap>
          {item.description}
        </Typography>
      </Box>
      <Typography level="body-xs" color="neutral" sx={{ flexShrink: 0, whiteSpace: 'nowrap' }}>
        {formatDistanceToNow(new Date(item.created_at), { addSuffix: true })}
      </Typography>
    </Stack>
  );
}
